'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { ErrorBoundary as InternalErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { ErrorFallback } from './ErrorFallback';
function defaultHandleError(error: Error, info: React.ErrorInfo): void {
  console.error('Error caught by boundary:', error);
  console.error('Component stack:', info.componentStack);
}
export type ErrorBoundaryProps = React.PropsWithChildren<{
  FallbackComponent?: React.ComponentType<FallbackProps & {
    componentStack?: string | null;
  }>;
  onError?: (error: Error, info: React.ErrorInfo) => void;
}>;
export const ErrorBoundary: React.FC<ErrorBoundaryProps> = t0 => {
  const $ = _c(8);
  const {
    children,
    FallbackComponent,
    onError
  } = t0;
  const componentStackRef = React.useRef(null);
  let t1;
  if ($[0] !== onError) {
    t1 = (error, info) => {
      componentStackRef.current = info.componentStack ?? null;
      (onError ?? defaultHandleError)(error, info);
    };
    $[0] = onError;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleError = t1;
  let t2;
  if ($[2] !== FallbackComponent) {
    t2 = props => {
      const Fallback = FallbackComponent ?? ErrorFallback;
      return <Fallback {...props} componentStack={componentStackRef.current} />;
    };
    $[2] = FallbackComponent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const FallbackWithStack = t2;
  let t3;
  if ($[4] !== FallbackWithStack || $[5] !== children || $[6] !== handleError) {
    t3 = <InternalErrorBoundary FallbackComponent={FallbackWithStack} onError={handleError}>{children}</InternalErrorBoundary>;
    $[4] = FallbackWithStack;
    $[5] = children;
    $[6] = handleError;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};